import { keys } from '../utilities/translator/translation_keys';
import { customColors } from '../utilities';
import { taskStatus } from '../utilities/tasks';

export const stringKeys = {
  about: 'ABOUT',
  actionItems: 'ACTION_ITEMS',
  assets: 'ASSETS',
  book: 'BOOK',
  color: 'COLOR',
  company: 'COMPANY',
  completed: 'COMPLETED',
  completedBy: 'COMPLETED_BY',
  create: 'CREATE',
  createdBy: 'CREATED_BY',
  dashboard: 'DASHBOARD',
  date: 'DATE',
  email: 'EMAIL',
  emailPlaceholder: 'EMAIL_PLACEHOLDER',
  failed: 'FAILED',
  fleet: 'ASSET',
  forgotPassword: 'FORGOT_PASSWORD',
  forms: 'FORMS',
  HSE: 'HSE',
  humanResources: 'HUMAN_RESOURCES',
  inProgress: 'IN_PROGRESS',
  inspectionHistory: 'INSPECTION_HISTORY',
  inspections: 'INSPECTIONS',
  inspectionTemplates: 'INSPECTION_TEMPLATES',
  licensePlate: 'LICENSE_PLATE',
  location: 'LOCATION',
  make: 'MAKE',
  model: 'MODEL',
  odometer: 'ODOMETER',
  outcome: 'OUTCOME',
  passed: 'PASSED',
  password: 'PASSWORD',
  passwordPlaceholder: 'PASSWORD_PLACEHOLDER',
  privacy: 'PRIVACY',
  progress: 'PROGRESS',
  settings: 'SETTINGS',
  signIn: 'SIGN_IN',
  signInDesc: 'SIGN_IN_DESC',
  signInLeftDesc: 'SIGN_IN_LEFT_DESC',
  signInLeftHeader: 'SIGN_IN_LEFT_HEADER',
  signOut: 'SIGN_OUT',
  signUpPost: 'SIGN_UP_POST',
  signUpPre: 'SIGN_UP_PRE',
  status: 'STATUS',
  subtitle: 'SUBTITLE',
  subtype: 'SUBTYPE',
  templates: 'TEMPLATES',
  terms: 'TERMS',
  title: 'TITLE',
  type: 'TYPE',
  unitNumber: 'UNIT_NUMBER',
  units: 'UNITS',
  vehicle: 'VEHICLE',
  vehicleCreateP1Title: 'VEHICLE_CREATE_P1_TITLE',
  vehicleCreateP1Subtitle: 'VEHICLE_CREATE_P1_SUBTITLE',
  vehicleCreateP1Header: 'VEHICLE_CREATE_P1_HEADER',
  vehicleCreateP1Desc: 'VEHICLE_CREATE_P1_DESC',
  vehicleCreateP2Header: 'VEHICLE_CREATE_P2_HEADER',
  vehicleCreateP2Desc: 'VEHICLE_CREATE_P2_DESC',
  vehicleCreateP3Header: 'VEHICLE_CREATE_P3_HEADER',
  vehicleCreateP3Desc: 'VEHICLE_CREATE_P3_DESC',
  vehicleCreateP4Header: 'VEHICLE_CREATE_P4_HEADER',
  vehicleCreateP4Desc: 'VEHICLE_CREATE_P4_DESC',
  vehicleIdentificationNumber: 'VEHICLE_IDENTIFICATION_NUMBER',
  vehicles: 'VEHICLES',
  year: 'YEAR',
};

export const userRoles = {
  admin: 'ADMIN',
  user: 'USER',
};

export const userRoleStrings = {
  ADMIN: 'Admin',
  USER: 'Standard',
};

export const inspectionApprovalTypes = {
  approved: 'APPROVED',
  changesRequested: 'CHANGES_REQUESTED',
};

export const csvRequiredColumns = [
  'title',
  'description',
  'category',
  'input type',
  'required',
];

export const csvValidOperators = [
  'EQUALS',
  'NOT_EQUALS',
  'LESS_THAN',
  'GREATER_THAN',
  'LESS_EQUALS',
  'GREATER_EQUALS',
];

export const csvConditionalTriggerTypes = [
  'TEST',
  'TEXT',
  'TEXT_MULTI',
  'NUMBER',
  'SELECT_SINGLE',
  'SELECT_MULTI',
  'DATE',
  'DATE_TIME',
  'TIME',
];

export const csvInputTypes = [
  'TEXT',
  'TEXT_MULTI',
  'TEST',
  'IMAGE',
  'NUMBER',
  'SIGNATURE_SINGLE',
  'SIGNATURE_MULTI',
  'DATE',
  'USER',
  'USER_MULTI',
  'SELECT_SINGLE',
  'SELECT_MULTI',
  'TABLE',
  'FILE_SINGLE',
  'FILE_MULTI',
  'MATRIX',
  'DATE_TIME',
  'TIME',
  'AUDIO',
  'ASSET',
  'IMAGE_MULTI',
  'DROPDOWN_SINGLE',
  'DROPDOWN_MULTI',
  'SELECT_CHECKLIST',
  'GPS',
  'MESSAGE',
  'RISK_REGISTRY',
];

export const csvConditionalInputTypes = [
  'TEST',
  'TEXT',
  'TEXT_MULTI',
  'NUMBER',
  'IMAGE',
  'IMAGE_MULTI',
  'USER',
  'USER_MULTI',
  'SELECT_SINGLE',
  'SELECT_MULTI',
  'TABLE',
  'DATE',
  'SIGNATURE_SINGLE',
  'SIGNATURE_MULTI',
  'FILE_SINGLE',
  'FILE_MULTI',
  'MATRIX',
  'DATE_TIME',
  'TIME',
  'AUDIO',
  'SEND_NOTIFICATION',
  'SHOW_MESSAGE',
];

export const csvAdditionalDataInputTypes = [
  'TABLE',
  'SELECT_SINGLE',
  'SELECT_MULTI',
];

export const csvRequiredColumnData = [
  'title',
  'category',
  'input type',
  'required',
];

export const defaultAssessmentTypes = {
  fleet: {
    color: 'yellow',
    icon: 'local_shipping',
    title: keys.common.FLEET,
    key: 'VEHICLE',
    name: 'Asset',
    editable: false,
    active: true,
  },
  hse: {
    icon: 'health_and_safety',
    color: 'red',
    title: keys.common.HSE,
    key: 'HSE',
    name: 'HSE',
    editable: true,
    active: true,
  },
  incident: {
    icon: 'fmd_bad',
    color: 'red',
    title: keys.common.INCIDENT,
    key: 'INCIDENT',
    name: 'Incident',
    editable: false,
    active: true,
    path: 'incidents',
  },
  quality: {
    icon: 'auto_awesome',
    color: 'blue',
    title: keys.common.QUALITY,
    key: 'QUALITY',
    name: 'Quality',
    editable: false,
    active: true,
    path: 'quality',
  },
  commissioning: {
    icon: 'engineering',
    color: 'orange',
    title: keys.common.COMMISSIONING,
    key: 'COMMISSIONING',
    name: 'Commissioning',
    editable: true,
    active: true,
  },
  meeting: {
    icon: 'calendar_month',
    color: 'green',
    title: keys.common.MEETING,
    key: 'MEETING',
    name: 'Meeting',
    editable: false,
    active: true,
  },
  daily_report: {
    icon: 'assignment_ind_icon',
    color: 'darkBlue',
    title: keys.common.DAILY_REPORT,
    key: 'DAILY_REPORT',
    name: 'Daily Report',
    editable: true,
    active: true,
  },
  observation: {
    icon: 'content_paste_search',
    color: 'red',
    title: keys.common.OBSERVATION,
    key: 'OBSERVATION',
    name: 'Observation',
    editable: false,
    active: true,
    path: 'observations',
  },
  orientation: {
    icon: 'school',
    color: 'pink',
    title: keys.common.ORIENTATION,
    key: 'ORIENTATION',
    name: 'Orientation',
    editable: true,
    active: true,
  },
  maintenance: {
    icon: 'construction',
    color: 'purple',
    title: keys.common.MAINTENANCE,
    key: 'MAINTENANCE',
    name: 'Maintenance',
    editable: true,
    active: true,
  },
  emergency: {
    icon: 'emergency',
    color: 'darkRed',
    title: keys.common.EMERGENCY,
    key: 'EMERGENCY',
    name: 'Emergency',
    editable: true,
    active: true,
  },
  audit: {
    icon: 'fact_check',
    color: 'purple',
    title: 'Audit',
    key: 'AUDIT',
    name: 'Audit',
    editable: false,
    active: true,
    path: 'audits',
  },
  moc: {
    icon: 'sync_alt',
    color: 'blue',
    key: 'MOC',
    editable: false,
    active: true,
    name: 'MOC',
    title: 'MOC',
    path: 'quality',
  },
  external: {
    color: 'grey',
    icon: 'launch',
    title: 'External',
    key: 'EXTERNAL',
    name: 'External',
    editable: false,
    active: true,
  },
};

export const allTypesOption = {
  key: 'ALL_TYPES',
  icon: 'article',
  title: keys.common.ALL_TYPES,
  color: 'green',
  active: true,
  editable: false,
  label: 'All Types',
  id: 'All Types',
  value: null,
};

export function getAssessmentTypesByEditable(isEditable) {
  return Object.fromEntries(
    Object.entries(defaultAssessmentTypes)
      .filter(([, value]) => value.editable === isEditable)
      .sort(([a], [b]) =>
        a.localeCompare(b, undefined, { numeric: true, sensitivity: 'base' }),
      ),
  );
}

export const customTaskAssessmentType = {
  vehicle: {
    color: 'yellow',
    icon: 'local_shipping',
    title: keys.common.FLEET,
    key: 'VEHICLE',
    name: 'Asset',
  },
};

export const getColor = (value, assessmentTypes) => {
  if (!value) {
    return;
  }
  switch (value) {
    case 'maintenance':
      return customColors.PURPLE_LIGHT;
    case 'orientation':
      return customColors.PINK;
    case 'commissioning':
      return customColors.ORANGE;
    case 'vehicle':
    case 'fleet':
      return customColors.YELLOW;
    case 'meeting':
      return customColors.GREEN;
    default:
      return assessmentTypes[value]?.color ?? customColors.SECONDARY_LIGHT;
  }
};

export const sortAssessmentStrings = {
  dateCreated: keys.common.DATE,
  isDraft: keys.common.STATUS,
  title: keys.common.TITLE,
  creatorId: keys.common.CREATOR,
};
export const sortExpenseStrings = {
  dateCreated: 'Date Created',
  status: 'Status',
  dateModified: 'Date Modified',
  dateOfExpense: 'Expense Date',
};

export const sortIncidentStrings = {
  dateCreated: keys.common.DATE,
  status: keys.common.STATUS,
  creatorId: keys.common.CREATOR,
  title: keys.common.TITLE,
  type: keys.common.TYPE,
  subtype: keys.common.SUBTYPE,
};
export const sortTemplateStrings = {
  dateCreated: keys.common.DATE,
  isDraft: keys.common.STATUS,
  title: keys.common.TITLE,
  userId: keys.common.CREATOR,
};

export const sortVehicleStrings = {
  make: keys.assets.MAKE,
  model: keys.assets.MODEL,
  unitNumber: keys.assets.UNIT_NUMBER,
  dateCreated: keys.common.DATE_ADDED,
  year: keys.assets.YEAR,
};
export const sortActionItemStrings = {
  priority: keys.utilities.PRIORITY,
  title: keys.utilities.TITLE,
  creatorId: keys.utilities.CREATOR,
  assigneeId: keys.utilities.ASSIGNEE,
  status: keys.utilities.STATUS,
  dateCreated: keys.common.DATE,
};

export const sortTimecardStrings = {
  startTime: 'Start Time',
  endTime: 'End Time',
  billableHours: 'Hours',
  status: 'Status',
  poNumber: 'PO Number',
  dateModified: 'Date Modified',
};

export const sortFileStrings = {
  dateCreated: keys.common.DATE_ADDED,
  dateModified: keys.common.DATE_MODIFIED,
  name: keys.common.TITLE,
  expires: keys.action.EXPIRES,
};

export const sortTaskStrings = {
  dateCreated: keys.common.DATE_ADDED,
  title: keys.common.TITLE,
};

export const paths = {
  actionItems: 'actionitems',
  analytics: 'analytics',
  announcements: 'announcements',
  dashboard: 'dashboard',
  assessments: 'assessments',
  assets: 'assets',
  settings: '/settings',
  asset: 'asset',
  files: 'files',
  assessment: 'assessment',
  templates: 'templates',
  logout: 'logout',
  login: 'login',
  incidents: 'incidents',
  incident: 'incident',
  timecard: 'timecard',
  timecards: 'timecards',
  incidenttemplate: 'incidenttemplate',
  workspaceSettings: 'workspacesettings',
  workspaceFiles: 'files/workspace',
  expenses: 'expenses',
  expense: 'expense',
  signout: 'signout',
  observations: 'observations',
  observation: 'observation',
  user: 'user',
  tasks: 'tasks',
  toolbox: 'toolbox',
  audits: 'audits',
  cpa: 'cpa',
  users: 'users',
  role: '/role',
  checkIns: 'checkins',
  certifications: 'certifications',
  quality: 'quality',
  registry: 'registry',
};

export const templateFilePaths = {
  ExcelTemplate:
    'https://app.opasmobile.com/assets/templates/files/OPASTemplateCreatorExcel.xlsx',
  ImportInstructions:
    'https://app.opasmobile.com/assets/templates/files/OPASTemplateImportInstructions.pdf',
};

export function getRoute(workspaceId, path, extension, params) {
  return extension
    ? `/workspace/${workspaceId}/${path}/${extension}${params ? params : ''}`
    : `/workspace/${workspaceId}/${path}${params ? params : ''}`;
}
export function capitalizeTitle(title) {
  return title?.charAt(0).toUpperCase() + title?.slice(1).toLowerCase();
}

export const inputTypes = {
  image: 'IMAGE',
  number: 'NUMBER',
  test: 'TEST',
  text: 'TEXT',
  table: 'TABLE',
  user: 'USER',
  select: 'SELECT_SINGLE',
  multiSelect: 'SELECT_MULTI',
  checklist: 'SELECT_CHECKLIST',
  signature: 'SIGNATURE_SINGLE',
  multiSignature: 'SIGNATURE_MULTI',
  date: 'DATE',
  textMulti: 'TEXT_MULTI',
  matrix: 'MATRIX',
  time: 'TIME',
  dateTime: 'DATE_TIME',
  multiUser: 'USER_MULTI',
  message: 'MESSAGE',
  dropdownSingle: 'DROPDOWN_SINGLE',
  dropdownMulti: 'DROPDOWN_MULTI',
};

export const incidentStatus = {
  initiated: 'INITIATED',
  pending: 'PENDING',
  investigation: 'INVESTIGATION',
  complete: 'COMPLETE',
  closed: 'CLOSED',
  invalid: 'INVALID',
  commentRequired: 'COMMENT_REQUIRED',
  commentSubmitted: 'COMMENT_SUBMITTED',
};
export const searchParamKeys = {
  actionItem: 'actionitem',
  type: 'type',
  board: 'board',
  file: 'file',
  parent: 'parent',
  hidden: 'hidden',
  tab: 'tab',
  template: 'template',
  asset: 'asset',
  modalName: 'modalName',
  observation: 'observation',
  taskId: 'taskId',
  workspace: 'workspace',
};

export const offlineTextsStrings = {
  featureDisabled: ' Not Available Offline',
};

export const announcementIcons = {
  READ: { icon: 'check_circle', color: 'green' },
  SNOOZED: { icon: 'snooze', color: 'yellow' },
  UNREAD: { icon: 'new_releases', color: 'red' },
};

export const taskIntervalStringLookup = {
  ONE_TIME: keys.tasks.ONE_TIME,
  DAILY: keys.tasks.DAILY,
  MONTHLY: keys.tasks.MONTHLY,
  WEEKLY: keys.tasks.WEEKLY,
  BIWEEKLY: keys.tasks.BIWEEKLY,
  QUARTERLY: keys.tasks.QUARTERLY,
  ANNUALLY: keys.tasks.ANNUALLY,
  CUSTOM: 'Custom',
};

export const companyScopedKeys = [
  'timecards',
  'expenses',
  'announcements',
  'insights',
  'analytics',
  'settings',
  'tasks',
  'toolbox',
  'audits',
  'users',
  'incidents',
  'observations',
  'certifications',
  'checkins',
  'registry',
  'cpas',
  'reports',
  'templates',
];

export const printableTypes = [
  'application/pdf',
  'image/png',
  'image/jpeg',
  'image/gif',
  'image/svg+xml',
  'application/msword',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
];

export const quickActionTypes = {
  userLevel: 'USER',
  workspaceLevel: 'WORKSPACE',
  companyLevel: 'COMPANY',
};

export const assetTrackingTypes = {
  distance: 'distance',
  time: 'time',
  both: 'both',
};

export const specialTemplateTypes = ['OBSERVATION', 'AUDIT', 'INCIDENT'];
//im too lazy to rename this but this really means company wide now lol
export const qualityTemplateTypes = ['MOC', 'QUALITY'];
export const otherTemplateTypes = [
  ...specialTemplateTypes,
  ...qualityTemplateTypes,
];

export const assessmentStatus = {
  IN_PROGRESS: {
    title: keys.common.IN_PROGRESS,
    color: 'yellow',
  },
  COMPLETE: {
    title: keys.common.COMPLETE,
    color: 'green',
  },
  PENDING_ACTION: {
    title: keys.common.PENDING_ACTION,
    color: 'red',
  },
  PENDING_CPA: {
    title: keys.common.PENDING_CPA,
    color: 'red',
  },
  SUMMARY_RQD: {
    title: keys.common.SUMMARY_RQD,
    color: 'blue',
  },
  REVIEW: {
    title: keys.assessments.PENDING_REVIEW,
    color: 'orange',
  },
  CHANGE_REQUEST: {
    title: keys.assessments.CHANGE_REQUEST_NO_VAR,
    color: 'purple',
  },
};

const actionItemStatus = {
  BACKLOG: {
    title: keys.common.BACKLOG,
    variant: 'danger',
    color: 'red',
    key: 'BACKLOG',
  },
  TODO: {
    title: keys.common.TODO,
    variant: 'primary',
    color: 'blue',
    key: 'TODO',
  },
  IN_PROGRESS: {
    title: keys.common.IN_PROGRESS,
    variant: 'warning',
    color: 'yellow',
    key: 'IN_PROGRESS',
  },
  DONE: {
    title: keys.common.COMPLETE,
    variant: 'success',
    color: 'green',
    key: 'DONE',
  },
  DUPLICATE: {
    title: keys.action_items.DUPLICATE,
    variant: 'secondary',
    color: 'secondary',
    key: 'DUPLICATE',
  },
};

export const allStatuses = {
  ...assessmentStatus,
  ...taskStatus,
  ...actionItemStatus,
};
